import { render, staticRenderFns } from "./banji.vue?vue&type=template&id=39bed5c0&scoped=true&"
import script from "./banji.js?vue&type=script&lang=js&"
export * from "./banji.js?vue&type=script&lang=js&"
import style0 from "./banji.vue?vue&type=style&index=0&id=39bed5c0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39bed5c0",
  null
  
)

export default component.exports